export { consumeHandoffToken } from './consumeHandoffToken';
export { createHandoffRouteHandler } from './createHandoffRouteHandler';
export type { CreateHandoffRouteHandlerOptions } from './createHandoffRouteHandler';
export {
  multiAccountAutoAdd,
  MultiAccountAutoAddError,
} from './multiAccountAutoAdd';
export type {
  MultiAccountAutoAddOptions,
  SwitcherApi,
} from './multiAccountAutoAdd';
export { HandoffLanding } from './HandoffLanding';
export type { HandoffLandingProps } from './HandoffLanding';
export type {
  HandoffResult,
  HandoffSuccess,
  HandoffFailure,
  HandoffFailureReason,
  HandoffUser,
  ConsumeHandoffTokenOptions,
} from './types';

// Prep–Sign–Promote (v1.4)
export { PrepEmbed } from './PrepEmbed';
export type {
  PrepEmbedProps,
  PrepEmbedSignedEvent,
  PrepEmbedFailedEvent,
  PrepResultLike,
} from './PrepEmbed';
